// src/utils/imageUtils.js

// Funciones existentes
export const compressImage = (src, options = {}) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      let { width, height } = img;
      const maxWidth = options.maxWidth || 800;
      const maxHeight = options.maxHeight || 600;
      const quality = options.quality || 0.7;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
  });
};

export const processImagesInContent = async (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const images = doc.querySelectorAll('img');

  for (let img of images) {
    if (img.src.startsWith('data:image')) {
      const compressedSrc = await compressImage(img.src, { maxWidth: 800, maxHeight: 600, quality: 0.7 });
      img.src = compressedSrc;
    }
  }

  return new XMLSerializer().serializeToString(doc);
};

// Nueva función para manejar las URLs de imágenes
export const getImageUrl = (imagePath) => {
if (!imagePath) return null;

if (imagePath.startsWith('http')) {
  return imagePath;
}

if (imagePath.startsWith('uploads/')) {
  return `${process.env.REACT_APP_API_URL.replace('/api', '')}/${imagePath}`;
}

return `${process.env.REACT_APP_API_URL.replace('/api', '')}/uploads/${imagePath}`;
};

// Función de utilidad para validar imágenes
export const validateImage = async (file) => {
if (!file) return false;

// Verificar el tipo de archivo
if (!file.type.startsWith('image/')) {
  throw new Error('El archivo debe ser una imagen');
}

// Verificar el tamaño (máximo 5MB)
const maxSize = 5 * 1024 * 1024; // 5MB en bytes
if (file.size > maxSize) {
  throw new Error('La imagen no debe superar los 5MB');
}

return true;
};

// Función para manejar errores de carga de imágenes
export const handleImageError = (e, fallbackUrl = '/placeholder-image.jpg') => {
console.log('Error loading image:', e.target.src);
e.target.src = fallbackUrl;
e.target.onerror = null; // Prevenir bucle infinito
};